import { faker } from '@faker-js/faker'

import { Personalization, PersonalizationType } from '../../contracts/member/Personalization'
import { SupernovaResponse } from '../../foundation'
import { asBuilder } from '../asBuilder'

export const getMemberPersonalizations = asBuilder<SupernovaResponse<Personalization[]>>(
  (): SupernovaResponse<Personalization[]> => {
    const memberId = faker.number.int()

    return {
      timestamp: new Date().toISOString(),
      status: 200,
      message: 'success',
      body: [
        {
          id: faker.number.int(),
          memberId,
          personalizationType: PersonalizationType.FAVORITE_TREATMENTS,
          customerJourney: null,
          concernTagIdList: [],
          concernBodyPartTagIdList: [],
          treatmentIdList: [faker.number.int({ min: 1, max: 1000 }), faker.number.int({ min: 1, max: 1000 })],
        },
        {
          id: faker.number.int(),
          memberId,
          personalizationType: PersonalizationType.MY_CONCERN_BODY_PART_TAGS,
          customerJourney: null,
          concernTagIdList: [],
          concernBodyPartTagIdList: [faker.number.int({ min: 1, max: 1000 }), faker.number.int({ min: 1, max: 1000 })],
          treatmentIdList: [],
        },
        {
          id: faker.number.int(),
          memberId,
          personalizationType: PersonalizationType.MY_CONCERN_TAGS,
          customerJourney: null,
          concernTagIdList: [faker.number.int({ min: 1, max: 1000 }), faker.number.int({ min: 1, max: 1000 })],
          concernBodyPartTagIdList: [],
          treatmentIdList: [],
        },
        {
          id: faker.number.int(),
          memberId,
          personalizationType: PersonalizationType.MY_CUSTOMER_JOURNEY,
          customerJourney: 'FIND_TREATMENT',
          concernTagIdList: [],
          concernBodyPartTagIdList: [],
          treatmentIdList: [],
        },
      ],
    }
  },
)

export const getMemberPersonalization = asBuilder<SupernovaResponse<Personalization>>(
  (): SupernovaResponse<Personalization> => {
    const memberId = faker.number.int()

    return {
      timestamp: new Date().toISOString(),
      status: 200,
      message: 'success',
      body: {
        id: faker.number.int(),
        memberId,
        personalizationType: faker.helpers.enumValue(PersonalizationType),
        customerJourney: null,
        concernTagIdList: [],
        concernBodyPartTagIdList: [],
        treatmentIdList: [],
      },
    }
  },
)
